import { render } from "./ServicesPage.vue?vue&type=template&id=72ece842&scoped=true"
import script from "./ServicesPage.vue?vue&type=script&lang=js"
export * from "./ServicesPage.vue?vue&type=script&lang=js"

import "./ServicesPage.vue?vue&type=style&index=0&id=72ece842&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-72ece842"

export default script